import React from "react";
import PropTypes from "prop-types";

function InProgressSetIndicator({ data = {}, status }) {
  console.log("InProgressSetIndicator", data, status);
  const { gameMode, phase } = status;

  if (phase === "game_over") {
    return null; // Don't render anything if the game is over
  }

  return (
    <>
      {gameMode !== "tie_break_10" && (
        <div className="InProgressSetIndicator Score_Box">{data.games}</div>
      )}
      <div className="InProgressSetIndicator Score_Box CurrentScore_Box">
        {gameMode == "normal"
          ? data.points == 50
            ? "V"
            : data.points
          : data.tieBreakPoint}
      </div>
    </>
  );
}

InProgressSetIndicator.propTypes = {
  data: PropTypes.shape({
    games: PropTypes.number.isRequired,
    tieBreakPoint: PropTypes.number,
    points: PropTypes.number,
  }),
  status: PropTypes.shape({
    gameMode: PropTypes.string.isRequired,
    phase: PropTypes.string.isRequired,
  }),
};

export default InProgressSetIndicator;
